import React, { useState } from "react";
import "./UserRequestModal.css";
import { CheckIcon } from "../../../../icons/reactIcons";

interface Props {
  type: "accept" | "reject";
  data: any;
  onClose: () => void;
  onConfirm: (data: any, reason?: string) => void;
}

const UserRequestModal: React.FC<Props> = ({
  type,
  data,
  onClose,
  onConfirm,
}) => {
  const [reason, setReason] = useState("");

  const handleConfirm = () => {
    onConfirm(data, reason);
  };

  return (
    <div className="userRequest-modal-backdrop">
      <div className="userRequest-modal">
        <h2>{type === "accept" ? "Accept Request" : "Reject Request"}</h2>

        {type === "accept" ? (
          <>
            <div className="userRequest-modal-content">
              <div className="userRequest-icon">
                <div className="icon-check">
                  <CheckIcon fontSize={"54px"} color="black" />
                </div>
              </div>
              <p style={{ textAlign: "center", fontWeight: "bold" }}>
                Are you sure you want to accept this user?
                <br />
                This action cannot be undone.
              </p>

              <div className="user-info">
                <div className="user-info-detail">
                  <span className="info-label">Name:</span>
                  <span className="info-value">{data.displayName}</span>
                </div>
                <div className="user-info-detail">
                  <span className="info-label">Email:</span>
                  <span className="info-value">{data.email}</span>
                </div>
                <div className="user-info-detail">
                  <span className="info-label">Ph Number:</span>
                  <span className="info-value">{data.mobile}</span>
                </div>
              </div>
            </div>

            <div className="userRequest-modal-actions">
              <button onClick={onClose} className="userRequest-cancel-btn">
                Cancel
              </button>
              <button
                className="userRequest-submit-btn"
                onClick={handleConfirm}
              >
                Accept
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="userRequest-modal-content">
              <div className="user-info">
                <div className="user-info-detail">
                  <span className="info-label">Name:</span>
                  <span className="info-value">{data.displayName}</span>
                </div>
                <div className="user-info-detail">
                  <span className="info-label">Email:</span>
                  <span className="info-value">{data.email}</span>
                </div>
                <div className="user-info-detail">
                  <span className="info-label">Ph Number:</span>
                  <span className="info-value">{data.mobile}</span>
                </div>
              </div>

              <textarea
                placeholder="Enter Reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
                required
              />
            </div>

            <div className="userRequest-modal-actions">
              <button onClick={onClose} className="userRequest-cancel-btn">
                Cancel
              </button>
              <button
                className="userRequest-submit-btn"
                disabled={!reason.trim()}
                onClick={handleConfirm}
              >
                Reject
              </button>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default UserRequestModal;
